import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation/navigation.component';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { NavigationRoutingModule } from './navigation.routing.module';
import { VersionComponent } from './version/version.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { NotificacionesModule } from '../entidades/notificaciones/module';
import { PushNotificationsService } from '../../auxiliares/servicios/push-notifications.service';
import { DescargasModule } from './descargas/module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DecalComponent } from '../../componentes/decal/decal.component';
import { AbrirNuevaPestaniaDirective } from '../../auxiliares/directives/abrir-nueva-pestania.directive';
import { BarraMigasComponent } from '../../componentes/breadcrumb/barra-migas.component';

@NgModule({
  declarations: [
    NavigationComponent,
    VersionComponent,
    UsuarioComponent,
    AppSettingsComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    NavigationRoutingModule,
    NotificacionesModule,
    DescargasModule,
    DragDropModule,
    DecalComponent,
    AbrirNuevaPestaniaDirective,
    BarraMigasComponent,
  ],
})
export class NavigationModule {
  private pushService = inject(PushNotificationsService);
}
